// TypeScript 4.2-compatible stub for @vercel/analytics.
// Angular 12 (gen1) cannot upgrade TypeScript past 4.2 — newer @vercel/analytics versions
// use `export { type X }` syntax (TypeScript 4.5+) which causes TS1005 parser errors.
// This stub provides a self-contained inject() implementation so the package types are
// never parsed by the TypeScript compiler.
export function inject(_props?: Record<string, unknown>): void {
  if (typeof document === 'undefined') return;
  const s = document.createElement('script');
  s.src = '/_vercel/insights/script.js';
  s.defer = true;
  document.head.appendChild(s);
}
